import { useCallback, useEffect, useState } from 'react';
import { userInfoSync } from 'hub-http/userInfo';
import UniversalAssociationsSelectSearchResults from './UniversalAssociationsSelectSearchResults';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'atom... Remove this comment to see the full error message
import { deref, watch, unwatch } from 'atom';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { isError, isLoading, isResolved } from 'reference-resolvers/utils';
import get from 'transmute/get';
import { OrderedMap, Map as ImmutableMap } from 'immutable';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../r... Remove this comment to see the full error message
import UniversalAssociationOptionRecord from '../records/UniversalAssociationOptionRecord';
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import unescapedText from 'I18n/utils/unescapedText';
import { is } from 'immutable';
import enviro from 'enviro';
import { universalAssociationOptionComparator, mrrComparator } from '../helpers/parseUniversalEngagementAssociations';
import MissingPermissionState from './MissingPermissionState';
import { MrrUsdPropertyNames, PortalObjectTypeIds } from '../helpers/BETConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const optionsReducer = ({
  updatedOptionRecord,
  option,
  optionId,
  associationRecord,
  defaultValue,
  notMatchingValue
}) => {
  const updatedRecordMatchingOption = associationRecord.getIn(['associationOptionRecords', `${optionId}`], defaultValue);
  if (!is(option, updatedRecordMatchingOption)) {
    return notMatchingValue || updatedRecordMatchingOption;
  }
  return updatedOptionRecord;
};
const SearchResultsReferenceResolverWrapper = ({
  canEdit,
  emailRecipientsIds,
  engagementOrInteractionType,
  isSearching,
  onToggleSelectAssociation,
  readOnly,
  resolver,
  searchText,
  selectedAssociationRecord,
  selectedObjectTypeId,
  shouldDisableLastAssociation,
  OptionWrapperComponent,
  refetchOptions
}) => {
  const [searchError, setSearchError] = useState(null);
  const [searchAtoms, setSearchAtoms] = useState(ImmutableMap());
  const [searchResults, setSearchResults] = useState(OrderedMap({
    [selectedObjectTypeId]: selectedAssociationRecord
  }));
  const [currentSearchId, setCurrentSearchId] = useState(1);
  const [previousSearchText, setPreviousSearchText] = useState('');
  const [previousSelectedAssociationRecord, setPreviousSelectedAssociationRecord] = useState(selectedAssociationRecord);
  const getToggledOptionRecord = useCallback(() => {
    const removedRecord = previousSelectedAssociationRecord.get('associationOptionRecords').reduce((removedOptionRecord, option, optionId) => optionsReducer({
      associationRecord: selectedAssociationRecord,
      defaultValue: UniversalAssociationOptionRecord({
        objectId: +optionId
      }),
      option,
      optionId,
      updatedOptionRecord: removedOptionRecord
    }), undefined);
    const addedRecord = selectedAssociationRecord.get('associationOptionRecords').reduce((addedOptionRecord, option, optionId) => optionsReducer({
      associationRecord: previousSelectedAssociationRecord,
      notMatchingValue: option,
      option,
      optionId,
      updatedOptionRecord: addedOptionRecord
    }), undefined);
    return removedRecord || addedRecord;
  }, [previousSelectedAssociationRecord, selectedAssociationRecord]);

  // Handles updating search results in place when adding or removing an association
  useEffect(() => {
    const hasSelectedRecordOptionsChanged = !is(previousSelectedAssociationRecord.get('associationOptionRecords'), selectedAssociationRecord.get('associationOptionRecords'));
    const shouldUpdateSearchResults = isSearching && selectedObjectTypeId === previousSelectedAssociationRecord.get('toObjectTypeId') && hasSelectedRecordOptionsChanged;
    if (shouldUpdateSearchResults) {
      const toggledOptionRecord = getToggledOptionRecord();
      const updatedSearchResults = searchResults.updateIn([selectedObjectTypeId, 'associationOptionRecords', `${toggledOptionRecord.get('objectId')}`], option => option && option.set('isSelected', toggledOptionRecord.get('isSelected')));
      setPreviousSelectedAssociationRecord(selectedAssociationRecord);
      setSearchResults(updatedSearchResults);
    }
  }, [getToggledOptionRecord, isSearching, previousSelectedAssociationRecord, searchResults, selectedAssociationRecord, selectedObjectTypeId]);
  const cleanupAllWatchedAtoms = useCallback(() => {
    searchAtoms.forEach(unwatcher => unwatcher());
  }, [searchAtoms]);
  const watchSearchAtom = useCallback((searchId, searchAtom, searchHandler) => {
    setSearchAtoms(searchAtoms.set(searchId, () => unwatch(searchAtom, searchHandler)));
    watch(searchAtom, searchHandler);
  }, [searchAtoms]);
  const getFormattedDescription = useCallback(description => {
    if (!description) {
      return undefined;
    }
    return selectedObjectTypeId === CONTACT_TYPE_ID ? unescapedText('universalAssociationsSelect.optionFormatting.emailWrapper', {
      secondaryDisplayLabel: description
    }) : unescapedText('universalAssociationsSelect.optionFormatting.parentheses', {
      secondaryDisplayLabel: description
    });
  }, [selectedObjectTypeId]);
  const formatResponse = useCallback(response => {
    const results = get('results', response);
    if (!results.size) {
      return OrderedMap();
    }
    const optionRecords = results.reduce((acc, option) => {
      const objectId = +option.get('id');
      const isSelected = Boolean(selectedAssociationRecord.get('associationOptionRecords').find(optionRecord => optionRecord.get('objectId') === objectId && optionRecord.get('isSelected')));
      const description = option.get('description');
      // SecondaryDisplayLabels on a contact are to be wrapped in <> not () as they are emails

      const formattedSecondaryDisplayLabel = getFormattedDescription(description);

      // This is to only applied to contact records, and if we ever need legal basis for other object types, we can add it here
      const legalBasis = selectedObjectTypeId === CONTACT_TYPE_ID ? option.getIn(['referencedObject', 'properties', 'hs_legal_basis', 'value']) : '';
      const emailIfContact = option.getIn(['referencedObject', 'properties', 'email', 'value']);
      const mrrUsd53 = option.getIn(['referencedObject', 'properties', enviro.isQa() ? MrrUsdPropertyNames.qa : MrrUsdPropertyNames.prod, 'value']);
      return acc.set(option.get('id'), UniversalAssociationOptionRecord({
        isSelected: !!isSelected,
        objectId,
        objectTypeId: selectedObjectTypeId,
        primaryDisplayLabel: option.get('label'),
        secondaryDisplayLabel: formattedSecondaryDisplayLabel,
        legalBasis,
        emailIfContact,
        mrrUsd53
      }));
    }, ImmutableMap());
    let scopes = [];
    try {
      const {
        user
      } = userInfoSync();
      scopes = user.scopes || [];
    } catch (e) {
      // userInfoSync can throw an error if not mocked in a test environment.
      // It should always be available in an app environment.
    }
    const portalObjectTypeId = enviro.isQa() ? PortalObjectTypeIds.qa : PortalObjectTypeIds.prod;
    const sortedOptionsMap = optionRecords.sort((optionA, optionB) => selectedObjectTypeId === portalObjectTypeId && scopes.includes('call-engagement-block') ? mrrComparator(optionA, optionB, false) : universalAssociationOptionComparator(optionA, optionB, false));
    const resultRecord = selectedAssociationRecord.set('hasMore', get('hasMore', response)).set('offset', get('offset', response)).set('associationOptionRecords', sortedOptionsMap);
    return OrderedMap({
      [selectedObjectTypeId]: resultRecord
    });
  }, [getFormattedDescription, selectedAssociationRecord, selectedObjectTypeId]);
  const handleSearch = useCallback(response => {
    setSearchError(null);
    if (isError(response)) {
      if (response.reason.status === 403) {
        setSearchError(response);
        return;
      }
      throw response;
    }
    if (!isResolved(response)) {
      return;
    }
    const resultRecord = formatResponse(response);
    const resultRecordOptions = resultRecord.getIn([selectedObjectTypeId, 'associationOptionRecords']);
    const dedupedSelectedAssociationRecordOptions = selectedAssociationRecord.get('associationOptionRecords').toList().filter(option => {
      return !resultRecordOptions ? option.get('isSelected') : option.get('isSelected') && !resultRecord.getIn([selectedObjectTypeId, 'associationOptionRecords']).some(resultRecordOption => resultRecordOption.get('objectId') === option.get('objectId'));
    });
    let resultRecordWithSelectedOptions = resultRecord;
    if (!resultRecordWithSelectedOptions.size) {
      resultRecordWithSelectedOptions = resultRecord.set(selectedObjectTypeId, selectedAssociationRecord);
    }
    dedupedSelectedAssociationRecordOptions.forEach(option => {
      resultRecordWithSelectedOptions = resultRecordWithSelectedOptions.setIn([selectedObjectTypeId, 'associationOptionRecords', `${option.get('objectId')}`], option);
    });

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'OrderedMap<unknown, unknown>' is... Remove this comment to see the full error message
    setSearchResults(resultRecordWithSelectedOptions);
  }, [formatResponse, selectedAssociationRecord, selectedObjectTypeId]);

  // Handles searching
  useEffect(() => {
    if (!isSearching) {
      setSearchResults(OrderedMap({
        [selectedObjectTypeId]: selectedAssociationRecord
      }));
      setPreviousSearchText('');
    } else if (searchText !== previousSearchText || selectedObjectTypeId !== previousSelectedAssociationRecord.get('toObjectTypeId')) {
      const searchAtom = resolver.search({
        count: 20,
        offset: 0,
        query: searchText,
        requestOptions: {
          allPropertiesFetchMode: 'latest_version',
          omitSensitivityLevels: ['high', 'standard']
        }
      });
      const currentResult = deref(searchAtom);
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      setPreviousSearchText(searchText);
      setPreviousSelectedAssociationRecord(selectedAssociationRecord);
      if (isResolved(currentResult)) {
        handleSearch(currentResult);
      } else {
        setSearchResults(currentResult);
        watchSearchAtom(currentSearchId, searchAtom, handleSearch);
        setCurrentSearchId(currentSearchId + 1);
      }
    }
    return cleanupAllWatchedAtoms;
  }, [cleanupAllWatchedAtoms, currentSearchId, handleSearch, isSearching, previousSearchText, previousSelectedAssociationRecord, resolver, searchText, selectedAssociationRecord, selectedObjectTypeId, watchSearchAtom]);
  if ((searchError === null || searchError === void 0 ? void 0 : searchError.reason.status) === 403) {
    return /*#__PURE__*/_jsx(MissingPermissionState, {
      selectedAssociationRecord: selectedAssociationRecord
    });
  }
  if (isLoading(searchResults)) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      "data-selenium-test": "uas-search-results-loading-spinner",
      marginBlockStart: "400"
    });
  }
  return /*#__PURE__*/_jsx(UniversalAssociationsSelectSearchResults, {
    canEdit: canEdit,
    emailRecipientsIds: emailRecipientsIds,
    engagementOrInteractionType: engagementOrInteractionType,
    isSearching: isSearching,
    onToggleSelectAssociation: onToggleSelectAssociation,
    readOnly: readOnly,
    searchResults: searchResults,
    searchText: searchText || '',
    selectedObjectTypeId: selectedObjectTypeId,
    shouldDisableLastAssociation: shouldDisableLastAssociation,
    OptionWrapperComponent: OptionWrapperComponent,
    refetchOptions: refetchOptions
  });
};
export default SearchResultsReferenceResolverWrapper;